import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field, reduxForm, reset } from 'redux-form';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment';
import { Switch } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import styles from './styles';
import Button from '../../Button';
import formFields from './formFields';
import propTypes from './propTypes';
import CheckboxField from '../../../fields/reduxForm/GeneralCheckbox';
import ViewableTextField from '../../../fields/reduxForm/ViewableTextField';
import { required } from '../../../utilities/validators';

export const BuilderProfilePersonalForm = props => {
  const {
    classes,
    isUpdatingPersonalProfile,
    handleSubmit,
    initialValues,
    enableEditing,
    change,
    setEditing,
    showInSearch,
    setShowInSearch,
    isUpdatingShowInSearch,
    expiryDate,
    setExpiryDate,
  } = props;

  const [currentDateValue, setCurrentDateValue] = useState(null);

  const [isDeactivate, setIsDeactivate] = useState(initialValues.deactivate);
  const [isOthers, setIsOthers] = useState(initialValues.reason === 'Others');
  // const [showInSearch, setShowInSearch] = useState(initialValues.showInSearch);
  useEffect(() => {
    setShowInSearch(initialValues.showInSearch);
  }, [initialValues.showInSearch]);

  useEffect(() => {
    // Find field && create datepicker
    const datepicker = document.querySelector(
      '#building-licence-expiry-text-field',
    );
    if (datepicker) {
      enableDatePicker(datepicker);
    }
  });

  const enableDatePicker = async datePicker => {
    // Create datepicker
    const options = {
      dateFormat: 'd-m-Y',
      minDate: 'today',
      disableMobile: true,
      onChange: () => {
        handleDateChange(flatpicker);
      },
    };
    const flatpicker = await flatpickr(datePicker, options);
  };

  useEffect(() => {
    const datepicker = document.querySelector(
      '#building-licence-expiry-text-field',
    );
    if (datepicker) {
      const storageDate = moment(currentDateValue).format('DD-MM-YYYY');
      const displayDate = moment(currentDateValue).format('DD-MM-YYYY');
      change('custom:buildingLicExp', `${storageDate}`);
      datepicker.value = displayDate;
      datepicker.placeholder = displayDate;
    }
  }, [currentDateValue]);

  const handleDateChange = flatpicker => {
    const [selectedDate] = flatpicker.selectedDates;
    setCurrentDateValue(selectedDate);
  };

  const renderFormButton = () => {
    if (!enableEditing) {
      return (
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleEnableEditingClick}
          fullWidth
        >
          Edit
        </Button>
      );
    }

    return (
      // eslint-disable-next-line react/prop-types
      <div className={classes.formButtons}>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleFormCancel}
          disabled={isUpdatingPersonalProfile || isUpdatingShowInSearch}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isUpdatingPersonalProfile || isUpdatingShowInSearch}
        >
          {(isUpdatingPersonalProfile || isUpdatingShowInSearch) && (
            <CircularProgress size={20} />
          )}
          {(!isUpdatingPersonalProfile || isUpdatingShowInSearch) && 'Done'}
        </Button>
      </div>
    );
  };

  const handleFormCancel = e => {
    e.preventDefault();
    reset('BUILDER_PROFILE_PERSONAL');
    setEditing(false);
  };

  const handleEnableEditingClick = () => setEditing(true);
  console.log(
    "initialValues['custom:buildingLicExp']",
    initialValues['custom:buildingLicExp'],
    { expiryDate },
  );
  return (
    <form onSubmit={handleSubmit}>
      {formFields.map(field => {
        if (field.name === 'custom:buildingLicExp') {
          return (
            <div className={classes.formGroup}>
              {enableEditing ? (
                <>
                  <div className={classes.textLabel}>{field.props.label}</div>
                  <TextField
                    id="custom:buildingLicExp"
                    // label="Builder License Expiry"
                    type="date"
                    value={expiryDate}
                    className={classes.dateTextField}
                    onChange={e => {
                      setExpiryDate(e.target.value);
                    }}
                  />
                </>
              ) : (
                <div className={classes.textWrapper}>
                  <div className={classes.textLabel}>{field.props.label}</div>
                  <div
                    className={classes.textValue}
                    id={`${field.props.id}-text-value`}
                  >
                    {initialValues[field.name]}
                  </div>
                </div>
              )}
            </div>
          );
        }
        return (
          <div className={classes.formGroup} key={field.name}>
            <Field
              name={field.name}
              component={field.component}
              props={field.props}
              validate={field.validate}
              isEditing={enableEditing}
              textValue={initialValues[field.name]}
              initialValue={initialValues[field.name]}
              oldValue={initialValues[field.name]}
              normalize={field.normalize}
            />
          </div>
        );
      })}
      <div className={classes.formGroup}>
        <Field
          name="deactivate"
          component={CheckboxField}
          props={{
            id: 'deactivate-text-field',
            label: 'DEACTIVATE',
            disabled: 'disable',
          }}
          onChange={(e, value) => {
            setIsDeactivate(value);
          }}
          isEditing={enableEditing}
          textValue={initialValues.deactivate}
          initialValue={initialValues.deactivate}
          oldValue={initialValues.deactivate}
        />
      </div>
      {isDeactivate && (
        <div className={classes.formGroup}>
          <Field
            name="reason"
            component={ViewableTextField}
            props={{
              id: 'reason-drop',
              label: 'SELECT REASON',
              fullWidth: true,
              placeholder: '',
              select: true,

              options: [
                { name: 'Invalid', value: 'Invalid' },
                { name: 'Does not want leads', value: 'Does not want leads' },
                { name: 'Temporarily paused', value: 'Temporarily paused' },
                { name: 'Others', value: 'Others' },
              ],
            }}
            onChange={(e, value) => setIsOthers(value === 'Others')}
            isEditing={enableEditing}
            validate={[required]}
            textValue={initialValues.reason}
            initialValue={initialValues.reason}
            oldValue={initialValues.reason}
          />
        </div>
      )}
      {isDeactivate && isOthers && (
        <Field
          name="other_reason"
          component={ViewableTextField}
          props={{
            id: 'other-text-field',
            label: 'ENTER REASON',
            fullWidth: true,
          }}
          validate={[required]}
          isEditing={enableEditing}
          textValue={initialValues.other_reason}
          initialValue={initialValues.other_reason}
          oldValue={initialValues.other_reason}
        />
      )}
      <div className={classes.formGroup}>
        <Field
          name="showInSearch"
          component={() => (
            <Switch
              name="showInSearch"
              disabled={!enableEditing}
              // isEditing={enableEditing}
              checked={showInSearch}
              onChange={e => setShowInSearch(e.target.checked)}
            />
          )}
          textValue={initialValues.showInSearch}
          initialValue={initialValues.showInSearch}
          oldValue={initialValues.showInSearch}
        />
        <span className={classes.textLabel}>Show In Search</span>
      </div>
      <div className={classes.actionsRow}>{renderFormButton()}</div>
    </form>
  );
};

BuilderProfilePersonalForm.propTypes = propTypes;

export default reduxForm({
  form: 'BUILDER_PROFILE_PERSONAL',
})(withStyles(styles)(BuilderProfilePersonalForm));
